import React from 'react';
import { ArrowUpRightIcon, QuoteIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { CtaBand } from '../components/CtaBand';
import { testimonials } from '../data/testimonials';
import { clinic } from '../data/clinic';
export function Experiences() {
  const [featured, ...rest] = testimonials;
  return <>
      <PageHeader title="Ervaringen" crumbs={[{
      label: 'Ervaringen'
    }]} intro="Wat patiënten over Excellent Care Clinics zeggen op ZorgkaartNederland." data-id="element-578" data-mp="2d6zm30tllunm">
        <a href={clinic.zorgkaartUrl} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 hover:bg-primary-dark" data-id="element-579" data-mp="35ssq1dqmrfbz">
          Vertel uw ervaring
          <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-580" data-mp="3jrimcr5mlaza" />
        </a>
      </PageHeader>

      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20" data-id="element-581" data-mp="3olwpxgufyof1">
        <figure className="rounded-3xl bg-ink px-8 py-12 text-white sm:px-14 sm:py-16" data-id="element-582" data-mp="3v197ti5joj5x">
          <QuoteIcon className="h-10 w-10 text-cyan" aria-hidden="true" data-id="element-583" data-mp="3q3hfin0zmv17" />
          <blockquote className="mt-6 max-w-4xl font-display text-2xl font-medium leading-snug sm:text-[32px] sm:leading-[1.3]" data-id="element-584" data-mp="8lojxlf7cpju">
            “{featured.quote}”
          </blockquote>
          <figcaption className="mt-6 text-[15px] font-medium text-white/70" data-id="element-585" data-mp="hljwnuoeoslz">{featured.name}</figcaption>
        </figure>

        <ul className="mt-8 columns-1 gap-6 md:columns-2 lg:columns-3" data-id="element-586" data-mp="djg9i8sdjzkv">
          {rest.map(t => <li key={t.name} className="mb-6 break-inside-avoid rounded-3xl bg-surface p-7" data-id="element-587" data-mp="riy1ex0yvsyg">
              <QuoteIcon className="h-5 w-5 text-primary" aria-hidden="true" data-id="element-588" data-mp="mm7ogikgldh9" />
              <blockquote className="mt-4 text-[16px] leading-relaxed text-ink" data-id="element-589" data-mp="2tb443xjx1g0i">“{t.quote}”</blockquote>
              <p className="mt-5 text-sm font-semibold text-muted" data-id="element-590" data-mp="2odcc73j9ttwb">{t.name}</p>
            </li>)}
        </ul>
      </section>

      <CtaBand data-id="element-591" data-mp="saz7083vbyzw" />
    </>;
}